module.exports = __webpack_public_path__ + "static/media/logo.3ba0afb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1001
// module chunks = 0